// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2wnbP","head":"Table_head__3NjVw","col":"Table_col__3s7qx"};